import {FormatColorReset} from "@mui/icons-material";
import IsDocumentedBy from "./IsDocumentedBy";

export default class IsDocumentedByList {
  constructor(name, initialValue = [], namespace, admsNameSpace, notationNameSpace, schemaAgencyNameSpace, isEditor=false) {
    this.namespace = namespace;
    this.name = name;
    this.admsNameSpace = admsNameSpace;
    this.notationNameSpace = notationNameSpace;
    this.schemaAgencyNameSpace = schemaAgencyNameSpace;
    this.isDocumentedbyList = [];
    this.isEditor = isEditor;
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.addValueObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getObjList() {
    return this.isDocumentedbyList;
  }

  setObjList(fisDocumentedbyList) {
    this.isDocumentedbyList = fisDocumentedbyList;
  }

  removeValueObj(item, index) {
    if (index < 0 || index >= this.isDocumentedbyList.length) {
      return;
    }
    this.isDocumentedbyList.splice(index, 1);
  }

  addValueObj(obj) {
    const isDocumentedby = new IsDocumentedBy(this.name, obj, this.namespace, this.admsNameSpace, this.notationNameSpace, this.schemaAgencyNameSpace);
    this.isDocumentedbyList.push(isDocumentedby);
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON[this.namespace];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.addValueObj(value);
      }
    } else {
      if (!obj && this.isEditor) { // if it is undefined - either it is empty coming from editor ,
        // either it is empty coming from landing page. both need different handling
        this.addValueObj(obj);
      }
    }
  }

  getExpandedFormatValue() {
    const expandedList = [];
    for (let index = 0; index < this.isDocumentedbyList.length; index++) {
      const docItem = this.isDocumentedbyList[index];
      expandedList.push(docItem.getExpandedFormatValue());
    }
    return expandedList;
  }

  isEmpty() {
    let condition = true;
    for (let index = 0; index < this.isDocumentedbyList.length; index++) {
      const docItem = this.isDocumentedbyList[index];
      condition = condition && docItem.isEmpty();
    }
    return condition;
  }
}
